export function scrollToTop() {

    let scrollBtn       = document.querySelector('.js-scroll-up');

    scrollBtn.addEventListener('click', (e) => {
        e.preventDefault();

        document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    return 'scrollToTop';
}
